// Modül Bazlı Lisanslama — Ruling 64 (P3Ö-3): PM'nin KİŞİYE ÖZEL uçlarını her uygulama
// açılışında / pano ziyaretinde KENDİLİĞİNDEN çağıran yüzeylerin (performans gelen kutusu rozeti,
// takdir duvarı kartı) kapısı.
//
// KÖK NEDEN: bu iki yüzey yalnız `hasModule('PM')` (kiracı aboneliği) soruyordu. PM ölçümlü bir
// kiracıda koltuksuz çalışanın PM self-servis uçları `RequireModuleSeat("PM")` ile 403 döner; rozet
// ve kart her açılışta/pano ziyaretinde bu 403'ü tetikliyor, ardından api.js'in 403 kendini-onarma
// yolu en pahalı auth çağrısını (refresh-session = SwitchTenant + /me) yapıyor ve ana sayfada her
// ziyarette kırmızı hata toast'ı çıkıyordu (20.000 çalışanlı kiracıda 19.000 kişi).
//
// DÜZELTME: `hasModule('PM') && hasSeat('PM')`. hasSeat (AuthContext → resolveHasSeat) ölçümsüz
// modülde, varsayılan modülde ve `seats` alanı henüz olmayan eski oturumda TRUE döner — yani
// ölçümsüz kiracıda davranış bugünküyle BİREBİR aynıdır (DEĞİŞMEZ 0); yalnız ölçümlü PM'de
// koltuğu olmayan kişi için yüzey hiç mount edilmez / istek atılmaz. Takdir duvarı PM özelliğidir,
// kapıda KALIR (ürün kararı: şirket geneli duvar koltuğa bağlı).
//
// Ayrı saf dosya: resolveHasHaModule.js ile AYNI gerekçe — DashboardPage/SidebarMenu'yü test
// dosyasından import etmek CRA5 + axios ESM zincirine toslar; bu dosya hiçbir şey import etmez.
export function resolveCanUsePm({ hasModule, hasSeat }) {
  return hasModule('PM') && hasSeat('PM');
}
